import { Component } from '@angular/core';
import { FnModalService, FnTableConfig, FnTableMetaData, FnToasterService, FnUtilService, TABLE_ACTION_TYPE, TableAction } from 'foundation';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { EOProduct, EOStatusType } from '../../../modal/entity.modal';
import { PosHttpService } from '../../../services/pos.http.service';
import { Subject } from 'rxjs';
import html2canvas from 'html2canvas';
import { HistInfoModelComponent } from './hist-info-model/hist-info-model.component';

@Component({
  selector: 'app-app-status-history',
  templateUrl: './app-status-history.component.html',
  styleUrl: './app-status-history.component.scss'
})
export class AppStatusHistoryComponent {
  constructor(private fnModalSvcs: FnModalService, public datepipe: DatePipe, private fnutilservice: FnUtilService, private route: ActivatedRoute,
    private router: Router, private posHttpSvcs: PosHttpService, private toaster: FnToasterService) {
  }

  customFlag = false;
  startDate: any;
  endDate: any;
  currentDate = new Date();
  selectProduct: any;
  selectIdenNo: any;
  showData = false;
  productArray: EOProduct[] = [];
  idenNoArray: EOStatusType[] = [];
  maxDateRange = new Date();
  isDisabled = false;
  isResolvedBySystem = false;
  uiMap = {
    isDataLoaded: false,
  };
  refPrimaryKey: any;
  description = "";

  backtoDashboard() {
    this.router.navigate(['/app/main/dashboard']);
  }

  dateRangeObject = {
    startDate: new Date(),
    endDate: new Date()
  };

  changeDate(event: any) {
    this.startDate = this.datepipe.transform(event.startDate, 'yyyy-MM-dd');
    this.endDate = this.datepipe.transform(event.endDate, 'yyyy-MM-dd');
  }

  ngOnInit() {
    this.dateRangeObject.startDate.setDate(this.currentDate.getDate() - 28);
    this.dateRangeObject.endDate.setDate(this.currentDate.getDate());
    this.startDate = this.datepipe.transform(this.dateRangeObject.startDate, 'yyyy-MM-dd');
    this.endDate = this.datepipe.transform(this.dateRangeObject.endDate, 'yyyy-MM-dd');
    this.loadEOProduct();
    this.route.queryParams.subscribe(params => {
      this.refPrimaryKey = params['pk'];
      const product = params['product'];
      const idenNo = params['idenNo'];
      
      this.getIdenNoData(() => {
        if (idenNo) {
          this.selectIdenNo = idenNo;
        }
        if (this.selectIdenNo) {
          this.getHistData(this.selectIdenNo);
        }
      });

      if (this.refPrimaryKey) {
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: {},
          replaceUrl: true
        });
      }
    });
  }

  loadEOProduct() {
    this.posHttpSvcs.authGet('v1/ui/loadProductName', 'loadProductName').subscribe((resp: any) => {
      if (resp.isError) {
        this.toaster.error('Product name not loaded');
        return;
      }
      this.productArray = resp.data;
    });
  }

  filterIdenNo() {
    this.selectIdenNo = '';
    this.posHttpSvcs.authPost('v1/ui/loadIdenNo', 'loadIdenNo', this.selectProduct).subscribe((resp: any) => {
      if (resp.isError) {
        this.toaster.error('Product not Selected');
        return;
      }
      this.idenNoArray = resp.data;
    })
  }

  getIdenNoData(callback?: () => void) {
    this.posHttpSvcs.authGet('v1/ui/loadEOStatusType', 'loadEOStatusType').subscribe((resp: any) => {
      if (resp.isError) {
        this.toaster.error('Iden number not Selected');
        return;
      }
      this.idenNoArray = resp.data;
      if (this.idenNoArray.length === 1) {
        this.selectIdenNo = this.idenNoArray[0].primaryKey;
      }
      if (callback) callback();
    });
  }

  getHistData(selectIdenNo: number) {
    if (!this.customFlag && this.fnutilservice.isEmptyObject(this.selectIdenNo)) {
      this.toaster.error('StatusType cannot be blank');
      return;
    }
    if (this.customFlag && this.fnutilservice.isEmptyObject(this.description)) {
      this.toaster.error('AlertID cannot be blank');
      return;
    }
    const requestMap: any = {
      startDate: this.startDate,
      endDate: this.endDate,
      customFlag: this.customFlag
    }
    if (this.customFlag) {
      requestMap.alertID = this.description;
    } else {
      requestMap.idenNo = selectIdenNo;
    }


    this.posHttpSvcs.authPost('v1/ui/loadAlertHistory', 'loadAlertHistory', requestMap).subscribe((resp: any) => {
      if (resp.isError) {
        this.toaster.error('Something went wrong');
        this.uiMap.isDataLoaded = false;
        return;
      }
      this.alertHistoryArray = resp.data;
      this.refreshTableData();
      this.uiMap.isDataLoaded = true;
    })
  }

  alertHistoryArray: Array<{
    alertID: string;
    product: string
    alertInfo: string;
    schema: string;
    description: string;
    priority: string;
    count: string;
    resolvedAt: string;
    resolvedBy: string;
    viewedAt: string;
    viewedBy: string;
    source: string;
    idenNo: string;
  }> = [];


  downloadCsv() {
    const headers = ['Alert ID', 'Product', 'Alert Info', 'Schema', 'Description', 'Priority', 'Count', 'Resolved At', 'Resolved By', 'Acknowledged', 'Acknowledge By', 'Sender'];
    const csvData = (this.alertHistoryArray as any[]).map(row => [
      row.alertID || '',
      row.product || '',
      row.alertInfo || '',
      row.schema || '',
      row.description || '',
      row.priority || '',
      row.count || '',
      row.resolvedAt || '',
      row.resolvedBy || '',
      row.viewedAt || '',
      row.viewedBy || '',
      row.source || '',
      row.idenNo,
    ]);

    let csvContent = 'data:text/csv;charset=utf-8,';
    csvContent += headers.join(',') + '\n';
    csvContent += csvData.map(e => e.map(value => `"${value}"`).join(',')).join('\n');

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', 'alert_history_report.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  // downloadTableScreenshot(): void {
  //   const tableElement = document.querySelector('#main-content');
  //   if (!tableElement) {
  //     return;
  //   }    
  //     html2canvas(tableElement as HTMLElement, {
  //       useCORS: true,
  //       backgroundColor: '#fff', 
  //       scale: 2, 
  //       scrollX: 0,
  //       scrollY: 0
  //     })
  //       .then(canvas => {
  //         const dataUrl = canvas.toDataURL('image/png', 0.8);
  //         const link = document.createElement('a');
  //         link.href = dataUrl;
  //         link.download = 'table_screenshot.png';
  //         document.body.appendChild(link);
  //         link.click();
  //         document.body.removeChild(link);
  //       })
  //       .catch(error => {
  //         console.error('Error capturing table screenshot:', error);
  //       });
  //   }
    
  
  refreshTableData() {
    if (this.config.tableAction.closed) {
      this.config.tableAction = new Subject<TableAction>();
    }
    this.config.tableAction.next({
      data: this.alertHistoryArray,
      action: TABLE_ACTION_TYPE.REFRESH,
    });
  }
  
  infoRowAction(row: any) {
    const RowInfoModel = this.fnModalSvcs.openCustomModal(HistInfoModelComponent, {
      data: {
        extraInfo: row.alertID
      },
      hasBackdrop: true,
      width: '1000px'
    })
    RowInfoModel.backdropClick().subscribe(() => {
      RowInfoModel.close();
    })
  }

  helpDetails(row: any) {
        if (this.fnutilservice.isEmptyObject(row.helpUrl)) {
          this.toaster.error("No help configured");
          return;
        } else {
          window.open(row.helpUrl, '_blank');
        }  
  }

  config: FnTableConfig = {
    uniqueKey: 'primaryKey',
    defaultSortKey: 'primaryKey',
    tableAction: new Subject<TableAction>(),
    hideAction: false,
    hideDelete: true,
    hideEdit: true,
		isCustomTemplate: true
  };

  rowMetaArray: FnTableMetaData[] = [
    {
      key: 'primaryKey',
      description: 'Primary Key',
      isHidden: true,
      isSortable: true,
      type: 'number',
    },
    {
      key: 'alertID',
      description: 'ID',
      type: 'string',
      isSortable: true,
    },
    {
      key: 'idenNo',
      description: 'IdenNo',
      type: 'string',
      isSortable: true,
    },
    {
      key: 'priority',
      description: 'Severity',
      type: 'string',
      isSortable: true,
    },
    {
      key: 'alertStartedAt',
      description: 'startedAt',
      type: 'datetime',
      isSortable: true,
    },
    {
      key: 'alertInfo',
      description: 'Alert Info',
      type: 'string',
      isSortable: true,
    },
    {
      key: 'description',
      description: 'Description',
      type: 'string',
      isSortable: true,
    },
    {
      key: 'source',
      description: 'Sender',
      type: 'string',
      isSortable: true,
    },
    {
      key: 'count',
      description: 'Alert Count',
      type: 'string',
      isSortable: true,
    },
    {
      key: 'resolvedAt',
      description: 'Resolved At',
      type: 'datetime',
      isSortable: true,
    }
  ];
}
